import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Popover, Descriptions} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import HttpTool from "../../../tool/HttpTool";
import styles from "./index.less";

export default class ConsultList extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.getWorkOrderList,
        otherParam: null,
      },
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: '请输入用户名称搜索',
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.name = value.keyword
            }
            delete value.keyword

            return true;
          },
        }
      }
    }
  }


  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18, offset: 0},
      },
      parameterArr: [
        {
          field: "status",
          name: "处理状态",
          type: 'select',
          selectType: 'value',
          reg: (v) => {
            return true;
          },
          option: {
            allowClear: true,
          },
          data: [
            {
              title: '已处理',
              value: 'processed',
            },
            {
              title: '未处理',
              value: 'untreated',
            },
          ]
        },
      ],
    }
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        render: (text, record, index) => {
          return <div>{index + 1}</div>
        }
      },
      {
        title: '用户名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '企业名称',
        dataIndex: 'companyName',
        key: 'companyName',
      },
      {
        title: '联系电话',
        dataIndex: 'phoneNumber',
        key: 'phoneNumber',
      },
      {
        title: '需求描述',
        dataIndex: 'need',
        key: 'need',
        width: 250,
        render: (text, record, index) => {
          return <Popover
            title={"描述详情"}
            content={
              <div
                style={{maxWidth: '50vw'}}
              >
                {text}
              </div>
            }
          >
            <div
              style={{width: '250px'}}
              className={styles.oneLineText}
            >
              {text}
            </div>
          </Popover>
        }
      },
      {
        title: '处理状态',
        dataIndex: 'status',
        key: 'status',
        render: (text) => {
          return text === 'processed' ? <span style={{color: 'dodgerblue'}}>已处理</span> :
            <span style={{color: 'darkorange'}}>未处理</span>
        }
      },
      {
        title: '提交时间',
        dataIndex: 'addTime',
        key: 'addTime',
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>
        }
      },
      {
        title: '扩展信息',
        dataIndex: 'extend',
        key: 'extend',
        render: (text, record) => {
          return <Popover
            title={"详情"}
            content={
              <div
                style={{width: '300px'}}
              >
                <Descriptions column={1}>
                  <Descriptions.Item label="所属行业">{record.extend?.industry || '-'}</Descriptions.Item>
                  <Descriptions.Item label="应用场景">{record.extend?.scene || '-'}</Descriptions.Item>
                  <Descriptions.Item label="企业邮箱">{record.extend?.email || '-'}</Descriptions.Item>
                </Descriptions>
              </div>
            }
          >
            查看
          </Popover>
        }
      },
      {
        title: '操作',
        width: 200,
        render: (text, record, index) => {
          return (
            <div>
              {
                this.powerConfig.Edit
                  ? (record.status === 'processed' ? <span onClick={() => {
                      this.changeState(record._id, 'untreated')
                    }} style={{color: "darkorange"}} className={styles.btnCopy}>{"改为未处理"}</span> :
                    <span onClick={() => {
                      this.changeState(record._id, 'processed')
                    }} style={{color: "dodgerblue"}} className={styles.btnEdit}>{"标记为已处理"}</span>)
                  : null
              }
            </div>
          )
        }
      },
    ]
  }

  changeState(id, status) {
    Modal.confirm({
      title: '提示',
      content: "确定" + (status === 'processed' ? "处理" : "取消处理") + "该咨询工单吗？",
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        let param = {
          _id: [id],
          status,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({loading: false}, () => {
            message.success('操作成功');
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({loading: false}, () => {
            message.error(msg);
          });
        };

        this.setState({loading: true});

        HttpTool.post(APILXD.updateWorkOrderStatus, successCB, failureCB, param);
      }
    })
  }
}